import { generatePath } from "@/routes/generatePath";

export const path = {
  financialRecords: {
    route: "/financial-managements/financial-records",
    link: () => path.financialRecords.route,
  },
  walletBalance: {
    route: "/financial-managements/wallet-balance",
    link: () => path.walletBalance.route,
  },
  withdraw: {
    route: "/financial-managements/wallet-balance/withdraw",
    link: () => path.withdraw.route,
  },
  deposit: {
    route: "/financial-managements/wallet-balance/deposit/:id",
    link: (id: string) =>
      generatePath("/financial-managements/wallet-balance/deposit/:id", { id }),
  },
  doctorFinancialRecords: {
    route: "/financial-managements/doctor-financial-records",
    link: () => path.doctorFinancialRecords.route,
  },
};
